import React from 'react';

import classess from "./Burger.css";
import BurgerIngredient from "./BurgerIngredient/BurgerIngredient";

const burger = (props) => {
    let transformedIngredients = Object.keys(props.ingredints).map(ingr => {
        return [...Array(props.ingredints[ingr].amount)].map((_, i) => <BurgerIngredient key={ingr + i} type={ingr} />)
    }).reduce((arr, el) => [...arr, ...el], []);

    if (transformedIngredients.length === 0) {
        transformedIngredients = <p>Please, Pick your choice</p>;
    }

    return (<div className={classess.Burger}>

        <BurgerIngredient type="bread-top" />
        {transformedIngredients}
        <BurgerIngredient type="bread-bottom" />

    </div>);
}

export default burger;